<div [hidden]="!active" class="container">
    <ng-content></ng-content>
</div>